/** Total free swatches a General-group customer may hold across the whole cart. */
export const SWATCH_TOTAL_CAP = 10;

export const swatchLimitEach = () =>
  Math.max(1, parseInt(window.theme.swatchLimitEach, 10) || 1);

/** Trade groups get a per-swatch allowance instead of the cart-wide cap. */
export const swatchCapApplies = () => swatchLimitEach() === 1;

export const countCartSwatches = (cartData) =>
  (cartData?.items || []).reduce(
    (total, item) =>
      item.properties?._is_swatch === "true" ? total + item.quantity : total,
    0,
  );
